import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const UpgradeRequired = () => {
  return (
    <div>
      <div
        className={tw`border-2 border-gray-400 w-2/3 mx-auto my-20 px-2 py-4 text-lg text-center`}
        style={{ boxShadow: " 0px 3px 3px 2px gray" }}
      >
        <p className={tw` font-bold text-primary `}>
          To maintain access to our full suite of permium features and services,
          an upgarde is necessary. Enhance your experience with advanced tools,
          superior performance, and priority support.
        </p>
      </div>
      <div className={tw`flex  items-center justify-center my-5`}>
        <div className={tw`flex-1 border-b border-black mx-2`}></div>
        <div className={tw`text-2xl font-bold text-black`}>
          Your Current Plan
        </div>
        <div className={tw`flex-1 border-b border-black mx-2`}></div>
      </div>
      <div className={tw`w-full flex justify-center `}>
        <div className={tw` w-64 rounded-lg border border-primary flex flex-col gap-y-6 bg-primary-light `}>
            <div className={tw`text-center mt-2`}>
            <p className={tw`text-xl font-semibold`}>Basic</p>
            <p className={tw`text-2xl font-semibold mt-2`}><sup className={tw`text-sm  text-gray-500 font-normal`}>Only</sup>Rs.9999 <span className={tw`text-sm text-gray-500 font-normal`}>/mounth</span></p>
            </div>
         
          <div>
            <ul className={tw`text-xs list-disc px-6 text-gray-500 `}>
              <li>Real-Time Shipment Tracking</li>
              <li>Basic Analytics</li>
              <li>Email Support</li>
            </ul>
          </div>
          <div className={tw`flex justify-between items-center  px-4 text-white bg-primary py-1`}>
            <span>Get Started</span>
            <span>&#62;</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradeRequired;
